<script>
	import API from './Stores/API';
	import View from './Stores/View';

	API.setAuthentication();
</script>

<svelte:component this="{$View.component}"/>